import { useQuery } from "react-query";
import axios from "infra/http";
import { CobrancaContaDetailsItem } from "../typings";

function useDetalhesContaTaxasAtualizadas({
  unidadeId,
  contaId,
  dataPosicao,
  taxasModificadas,
}: {
  unidadeId: string;
  contaId: string;
  dataPosicao: string;
  taxasModificadas?: Record<
    string,
    {
      taxaMulta: number;
      taxaJuros: number;
      taxaCobranca: number;
    }
  >;
}) {
  return useQuery(
    [
      `/v1/cobranca/${unidadeId}/detalhes-conta/${contaId}`,
      taxasModificadas,
      dataPosicao,
    ],
    async () => {
      const res = await axios.post<CobrancaContaDetailsItem>(
        `/v1/cobranca/${unidadeId}/detalhes-conta/${contaId}`,
        taxasModificadas
          ? {
              taxasModificadas: Object.keys(taxasModificadas).map((key) => ({
                categoriaFinanceiraId: key,
                taxaMulta: taxasModificadas[key].taxaMulta,
                taxaJuros: taxasModificadas[key].taxaJuros,
                taxaCobranca: taxasModificadas[key].taxaCobranca,
              })),
            }
          : null,
        {
          params: { dataPosicao },
        }
      );

      return res.data;
    },
    {
      enabled: !!unidadeId && !!contaId && !!taxasModificadas,
    }
  );
}

export default useDetalhesContaTaxasAtualizadas;
